import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "22",
  height: "21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 22 21"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "m1.625 10.5 8.954-8.954c.44-.44 1.152-.44 1.591 0l8.955 8.954M3.875 8.25v10.125c0 .621.504 1.125 1.125 1.125h4.125v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V19.5h4.125c.621 0 1.125-.504 1.125-1.125V8.25M7.625 19.5h8.25",
  stroke: "currentColor",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }